// Textos de Marketing › Notificaciones push (envío manual a usuarios concretos).
// Se registran junto al resto de vocabularios en AppComponent; setTranslation
// los fusiona.
export const locale = {
  lang: 'es',
  data: {
    PUSH_NOTIFICATIONS: {
      NOTE_TITLE: 'Notificación push escrita a mano para usuarios concretos',
      NOTE_TEXT:
        'Se envía como notificación operativa, sin poder elegir la categoría, y con una petición por usuario. «Aceptada por el servidor» no quiere decir «entregada»: si el usuario no tiene dispositivos o ha desactivado esas notificaciones, no le llega.',
      RECIPIENTS_TITLE: 'Destinatarios',
      RECIPIENTS_SUB:
        'Hasta {{max}} usuarios por envío. Búscalos por nombre, email o teléfono.',
      RECIPIENTS_COUNT: 'Elegidos: {{count}} de {{max}}',
      RECIPIENTS_EMPTY: 'Todavía no has elegido a ningún usuario.',
      RECIPIENTS_MAX:
        'Ya tienes el máximo de {{max}} destinatarios. Quita alguno para añadir otro.',
      RECIPIENTS_LIST_ARIA: 'Destinatarios elegidos',
      REMOVE: 'Quitar',
      REMOVE_ARIA: 'Quitar a {{name}}',
      MESSAGE_TITLE: 'Mensaje',
      MESSAGE_SUB: 'Lo que verá el usuario en la notificación.',
      FIELD_TITLE: 'Título',
      FIELD_TITLE_PLACEHOLDER: 'P. ej.: Cambios en tu viaje de mañana',
      FIELD_BODY: 'Texto',
      FIELD_BODY_PLACEHOLDER: 'Escribe el mensaje de la notificación',
      SEND: 'Enviar',
      SENDING: 'Enviando {{done}} de {{total}}…',
      SEND_DISABLED_RECIPIENTS:
        'Elige al menos un destinatario para poder enviar',
      SEND_DISABLED_TITLE: 'Escribe el título para poder enviar',
      SEND_DISABLED_BODY: 'Escribe el texto para poder enviar',
      CONFIRM_TITLE: 'Enviar push (destinatarios: {{count}})',
      CONFIRM_TEXT:
        'Se envía a cada usuario por separado. No cierres la página hasta que termine.',
      CONFIRM_OK: 'Enviar',
      CONFIRM_CANCEL: 'Cancelar',
      RESULT_OK: 'Aceptadas por el servidor: {{ok}} de {{total}}',
      RESULT_FAILED: 'No se han podido enviar: {{count}}',
      RESULT_FAILED_HINT:
        'Se quedan como destinatarios, con el mismo mensaje, para que puedas reintentar.',
      ERROR_UNKNOWN: 'El servidor no ha dado el motivo.',
    },
  },
};
